const StringUtils = (() => {
  const service = {};

  service.toEmptyStringOnVoid = (value) => {
    const formattedValue = value === null || value === undefined ? '' : value;
    return formattedValue;
  };

  service.isValidUUID = (value) => {
    const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!value) {
      return false;
    }
    return isUUID.test(value);
  };

  /*
   * takes an object of this format:
   * {
   *   "amount": "354.810000",
   *   "currencyCode": "USD"
   * },
   *
   * and returns a string like:
   * "$354.81"
   */
  service.formatCurrency = (amountObject) => {
    if (!amountObject) {
      return amountObject;
    }
    if (!amountObject.amount) {
      return amountObject;
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: amountObject.currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(amountObject.amount));
  };

  return service;
})();

export default StringUtils;
